import { useState, useCallback } from 'react';

/**
 * 메모 편집 기능을 위한 커스텀 훅
 * @param {Object} props
 * @param {Function} props.saveFn - 저장 함수 (id, memo) => Promise
 * @param {Function} props.onUpdate - 저장/삭제 성공 시 호출할 콜백 (id, newMemo)
 * @returns {Object} 메모 편집 관련 상태 및 함수들
 */
export function useMemoEdit({ saveFn, onUpdate }) {
  const [isOpen, setIsOpen] = useState(false);
  const [memoData, setMemoData] = useState(null); // { id, currentMemo }
  const [loading, setLoading] = useState(false);

  /**
   * 모달 열기
   */
  const openModal = useCallback((adCampaignMetaId, currentMemo) => {
    setMemoData({ id: adCampaignMetaId, currentMemo });
    setIsOpen(true);
  }, []);

  /**
   * 모달 닫기
   */
  const closeModal = useCallback(() => {
    setMemoData(null);
    setIsOpen(false);
    setLoading(false);
  }, []);

  /**
   * 메모 저장
   */
  const save = useCallback(async (memoText) => {
    try {
      setLoading(true);
      await saveFn(memoData.id, memoText);
      onUpdate(memoData.id, memoText);
      closeModal();
    } catch (error) {
      alert(error.message);
      setLoading(false);
    }
  }, [memoData, saveFn, onUpdate, closeModal]);

  /**
   * 메모 삭제
   */
  const deleteMemo = useCallback(async () => {
    try {
      setLoading(true);
      await saveFn(memoData.id, null);
      onUpdate(memoData.id, null);
      closeModal();
    } catch (error) {
      alert(error.message);
      setLoading(false);
    }
  }, [memoData, saveFn, onUpdate, closeModal]);

  return {
    isOpen,
    memoData,
    loading,
    openModal,
    closeModal,
    save,
    deleteMemo,
  };
}
